module.exports = __webpack_public_path__ + "img/diet-standard.ff1dc420.png";